import produce from 'immer';
import { FormGroup } from '@angular/forms';
import { baseFormsActions } from '../actions';
import { BaseStaffRequestFormInterface } from '../../modules/inquiry/_interfaces/base-inquiry.interface';
import { FormRawValue } from '../../modules/inquiry/_interfaces/base-form.interface';
import { BaseRegisterFormInterface } from '../../modules/auth/_interfaces/base-register-form.interface';

export interface BaseFormsState {
  staffRequestForm: {
    data: FormRawValue<FormGroup<BaseStaffRequestFormInterface>> | undefined;
  };
  accountRegisterForm: {
    data: FormRawValue<FormGroup<BaseRegisterFormInterface>> | undefined;
  };
}

export const INITIAL_FORMS_STATE: BaseFormsState = {
  staffRequestForm: {
    data: undefined,
  },
  accountRegisterForm: {
    data: undefined,
  },
};

export function baseFormsReducer(state: BaseFormsState = INITIAL_FORMS_STATE, action: any): any {
  return produce(state, (draftState) => {
    switch (action.type) {
      // Request form
      case baseFormsActions.setStaffRequestForm.type:
        draftState.staffRequestForm.data = action.payload;
        return;

      case baseFormsActions.clearStaffRequestForm.type:
        draftState.staffRequestForm = INITIAL_FORMS_STATE.staffRequestForm;
        return;

      // Account register form
      case baseFormsActions.setAccountRegisterForm.type:
        draftState.accountRegisterForm.data = action.payload;
        return;

      case baseFormsActions.clearAccountRegisterForm.type:
        draftState.accountRegisterForm.data = undefined;
        return;
    }
  });
}
